import React, {useContext, useEffect, useState} from 'react';
import GoBack from "../../components/goBack";
import $ from "jquery";
import Select from "react-select";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import OrgContext from "../../organisation/OrgContext";
import Swal from 'sweetalert2';
import {API, baseURL} from '../../services/api';
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useAuthHelper from "../../helpers/AuthHelper";

function NewAccount(props) {
    const [accounts, setAccounts] = useState([]);
    const [selectedAccountType, setSelectedAccountType] = useState('');
    const [accountCode, setAccountCode] = useState('');
    const [accountDescription, setAccountDescription] = useState('');
    const [accountName, setAccountName] = useState('');
    const {organisation, changeOrg} = useContext(OrgContext);
    const navigate = useNavigate();
    const [t, i18n] = useTranslation();
    const [isSubmit, setIsSubmit] = useState(false);
    const {onlyComptable} = useAuthHelper();
    useEffect(() => {
        onlyComptable();
        // getAccounts();
        $('.some-fields-are-required-to-save').css('display', 'none');
    }, []);
    const save = async (event) => {
        if (
            selectedAccountType.length === 0 || selectedAccountType === '0' ||
            accountCode.length === 0 || accountName.length === 0
        ) {
            /**
             *
             * @type {string}
             */
            const errorMessage = 'Attention ! Il fait remplir tout les champs obligatoire';
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } else {
            $(".some-fields-are-required-to-save").css('display', 'none');
            const preparedObject = {
                name: accountName,
                type: selectedAccountType,
                description: accountDescription,
                code: accountCode,
                organization_id: organisation.id
            };
            setIsSubmit(true);
            const response = await jwtInterceoptor.post('/data/user/accounts', preparedObject).then(res => {
                setIsSubmit(false);
                Swal.fire(
                    t('Le compte a été ajouter avec succès'),
                    t(''),
                    'success'
                );
                navigate('/plancomptable/list')
            }).catch((error) => {
                setIsSubmit(false);
                console.log(error)
            });
        }
    }
    return (
        <>
            <ToastContainer/>
            <div className="main-container container-fluid">
                <GoBack route={"/plancomptable/list"}/>

                <div className="page-header">
                    <h1 className="page-title breadcumpsHeader">Compte comptable</h1>
                    <div>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="javascript:void(0)"
                                                               onClick={() => navigate('/plancomptable/list')}>Liste des plan comptable</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Ajouter un compte comptable</li>
                        </ol>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-xl-12">

                    <div className="card">
                        <div class="card-body">
                            <div
                                class="alert alert-danger alert-dismissible fade show mb-0 some-fields-are-required-to-save"
                                role="alert">
                                <span
                                    class="alert-inner--icon"><i class="fe fe-slash"></i></span><span
                                class="alert-inner--text"><strong></strong>Attention ! Les champs suivants sont obligatoire.</span>
                                <p>
                                    - le nom du compte <br/>
                                    - Le code du compte <br/>
                                    - le type du compte <br/>
                                </p>
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <br/><br/>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">Type de compte*</label>
                                <select className="form-select" id="buyPriceAccountInput"
                                        onChange={(e) => setSelectedAccountType(e.target.value)}
                                        value={selectedAccountType}>
                                    <option value="0">selectionner un type de compte</option>
                                    <option value="Autre actif courant">Autre actif courant</option>
                                    <option value="Espèces">Espèces</option>
                                    <option value="Comptes clients">Comptes clients</option>
                                    <option value="Actif fixe">Actif fixe</option>
                                    <option value="Autres engagements à court terme">Autres engagements à court terme
                                    </option>
                                    <option value="Comptes fournisseurs">Comptes fournisseurs</option>
                                    <option value="Autres engagements">Autres engagements</option>
                                    <option value="Capitaux">Capitaux</option>
                                    <option value="Revenus">Revenus</option>
                                    <option value="Dépenses">Dépenses</option>
                                    <option value="Coût des marchandises vendues">Coût des marchandises vendues</option>
                                    <option value="Autres dépenses">Autres dépenses</option>
                                    <option value="Stock">Stock</option>
                                    <option value="Liste des comptes de capitaux (classe 1)">Liste des comptes de capitaux (classe 1)</option>
                                    <option value="Liste des comptes d'immobilisations (classe 2)">Liste des comptes d'immobilisations (classe 2)</option>
                                    <option value="Liste des comptes de stocks et en-cours (classe 3)">Liste des comptes de stocks et en-cours (classe 3)</option>
                                    <option value="Liste des comptes de tiers (classe 4)">Liste des comptes de tiers (classe 4)</option>
                                    <option value="Liste des comptes de trésorerie (classe 5)">Liste des comptes de trésorerie (classe 5)</option>
                                    <option value="Liste des comptes de charges (classe 6)">Liste des comptes de charges (classe 6)</option>
                                    <option value="Liste des comptes de produits (classe 7)">Liste des comptes de produits (classe 7)</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">Nom du compte*</label>
                                <input type="text" placeholder="nom" className={`form-control `}
                                       onChange={(e) => setAccountName(e.target.value)}
                                       value={accountName}/>
                            </div>

                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">Description du compte</label>
                                <input type="text" placeholder="description" className={`form-control `}
                                       onChange={(e) => setAccountDescription(e.target.value)}
                                       value={accountDescription}/>
                            </div>

                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">Code du compte*</label>
                                <input type="text" placeholder="code" className={`form-control `}
                                       onChange={(e) => setAccountCode(e.target.value)}
                                       value={accountCode}/>
                            </div>

                            <div class="card-footer">
                                <div class="row">
                                    <div class="col-md-12"><button disabled={isSubmit} type={"button"}
                                                              className="btn btn-primary"
                                                              onClick={save}>{isSubmit ? t("Loading ...") : t("Enregistrer")}</button><a
                                                              onClick={()=>{
                                                                navigate(-1);
                                                            }}
                                                                                               className="btn btn-default float-end">Annuler</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NewAccount;